import docReady from 'doc-ready'

import { initContainers } from '../util/init'
import { updateLinkState } from '../util/link_state'

function commonInit (containers) {}

function setup () {
  const portfolioDetail = document.querySelector('.portfolio-detail')
  const index = document.querySelector('.index')
  const firms = document.querySelector('.firms')
  const hasCharts = portfolioDetail || index || firms
  let dashboard = []
  if (hasCharts) {
    dashboard = document.querySelectorAll('.dashboard')
  }
  initContainers(dashboard)

  const portfolios = document.querySelectorAll('.portfolios')
  initContainers(portfolios)

  const dashboardPortfolios = document.querySelectorAll('.portfolio-list.top-five')
  initContainers(dashboardPortfolios)

  const advisers = document.querySelectorAll('.advisers')
  initContainers(advisers)

  const selectCode = document.querySelectorAll('.overview__user--select-code')
  initContainers(selectCode)

  const toggleSwitch = document.querySelectorAll('.toggle-switch')
  initContainers(toggleSwitch)
}

function initContent () {
  // initialises newly loaded content
  const current = document.querySelectorAll('#content > article')
  initContainers(current)
  commonInit(current)
  updateLinkState(document.querySelectorAll('#header, #footer, #content'))
}

docReady(() => {
  setup()
  initContent()

  document.documentElement.classList.add('state-initialised')
})



// WEBPACK FOOTER //
// ./assets/j/src/site.js